import { Papel } from "service/restricao/Papeis"
import { BuscaSemAcesso, BuscaSemRestricao, SemRestricao, BuscaSomenteVisualizacao } from "service/restricao/PermissoesGenericas"

import { RestricoesCamposFormulario } from "../../service/restricao/RestricoesCamposFormulario"
import { OperacaoFormularioBusca } from "../../service/restricao/OperacaoFormulario/OperacaoFormulario"
import { RestricoesFormulario } from "../../service/restricao/RestricoesFormulario"
import { RestricaoBuscaFormulario } from "../../service/restricao/TipoRestricaoFormulario/RestricaoBuscaFormulario"


/**********************
  Campos do formulário em que se aplica as restrições
 **********************/
interface CamposRestricoes extends RestricoesCamposFormulario {
  nome: RestricaoBuscaFormulario;
  situacao: RestricaoBuscaFormulario;

  unidadeExercicio: RestricaoBuscaFormulario;
  restricaoUnidade: RestricaoBuscaFormulario;
}

/**********************
  Perfis
 **********************/
const UsuarioComum: Readonly<CamposRestricoes> = {
  nome: BuscaSemAcesso,
  situacao: BuscaSemAcesso,
  unidadeExercicio: BuscaSemAcesso,
  restricaoUnidade: BuscaSemAcesso,
}

const Nivel1: Readonly<CamposRestricoes> = {
  ...UsuarioComum,

  nome: BuscaSemRestricao,
  situacao: BuscaSomenteVisualizacao,
  unidadeExercicio: {
    [OperacaoFormularioBusca.Buscar]: {
      ...SemRestricao,
      clearable: true
    }
  },
  restricaoUnidade: BuscaSemRestricao,
}


/**********************
  Restrições por perfil
 **********************/
export const RestricoesBuscaServidoresFormulario: RestricoesFormulario<CamposRestricoes> = {
  [Papel.UsuarioComum]: UsuarioComum,
  [Papel.Nivel1]: Nivel1,
  [Papel.Nivel2]: Nivel1,
  [Papel.Administrador]: Nivel1,
}